(function ($) {
	class W4D_Filters {
		constructor() {
			if (!$('.filter').length) return;

			this.initSelectors();
			this.storeInitialOrder();
			this.handleResponsivePopovers();
			this.bindEvents();
			this.initializeFiltersFromURL();

			this.isExpanded = this.$filtersExpandAndClearContainer.hasClass('filters__expand-and-clear--expanded');
			this.initObserver();
			this.updateGlobalResetButtonVisibility();
		}

		initSelectors() {
			this.$filters = $('.filter');
			this.$sortFilter = $('.filter--sort');
			this.$resetAll = $('.filters__reset-all');
			this.$filtersContainer = $('.filters');
			this.$filtersToggle = $('.filters__toggle');
			this.$filtersClose = $('.filters__close');
			this.$filtersSubmit = $('.js-filters-toggle');
			this.$expandFiltersBtn = $('.filters__expand-btn');
			this.$filtersExpandAndClearContainer = $('.filters__expand-and-clear');
			this.$filtersWrapper = $('.filters__wrapper');
			this.$filtersWrapperOuter = $('.filters__wrapper-outer');
			this.$headerReset = this.$filtersContainer.find('.filters__header .filters__reset-all');
			this.$footerReset = this.$filtersContainer.find('.filters__expand-and-clear .filters__reset-all');
			this.mqMobile = window.matchMedia('(max-width: 992px)');
		}

		storeInitialOrder() {
			if (!this.$filtersWrapper.length) return;
			this.initialOrder = this.$filtersWrapper
				.children('.filter')
				.toArray()
				.map((el) => $(el).data('taxonomy'));
		}

		// TODO: On initial page load this should ideally be handled server-side (PHP):
		// parse URL params, apply them to the main query, and render products accordingly to avoid an extra AJAX roundtrip.
		// For now, we replicate previous Select2 behavior and trigger a single fetch here when URL contains filter params.
		initializeFiltersFromURL(isInitialLoad = true) {
			const url = new URL(window.location.href);
			const params = url.searchParams;

			let shouldFetch = false;

			this.$filters.each((i, el) => {
				const $filter = $(el);
				if ($filter.closest('.filters').length && $filter.attr('aria-hidden') === undefined) {
					$filter.attr('aria-hidden', 'false');
				}
				const taxonomy = $filter.data('taxonomy');
				const $panel = $filter.find('.filter__panel');

				// Reset filter UI before applying state from URL
				if ($filter.hasClass('filter--sort')) {
					$filter.find('.filter__option').removeClass('is-selected').attr('aria-selected', 'false');
					// We don't want to reset to 'default' yet because we'll check URL/Cookie below
				} else {
					$filter.find('input[type="checkbox"]').prop('checked', false);
				}

				// Discount toggle: boolean, no filter__option elements
				if ($filter.hasClass('filter--discount')) {
					const isActive = params.has(taxonomy) && params.get(taxonomy) === '1';
					$filter.find('input[type="checkbox"]').prop('checked', isActive);
					if (isActive) shouldFetch = true;
					return; // skip rest of loop body — no badge, no search, no visibleBounds
				}

				if (taxonomy && params.has(taxonomy)) {
					if (taxonomy !== 'price') {
						shouldFetch = true;
					}

					if ($filter.hasClass('filter--sort')) {
						const value = params.get(taxonomy);
						$filter.find(`.filter__option[data-value="${value}"]`).addClass('is-selected').attr('aria-selected', 'true');
					} else {
						const filterValues = params.get(taxonomy).split(',');

						filterValues.forEach((value) => {
							$filter.find(`.filter__option[data-value="${value}"] input[type="checkbox"]`).prop('checked', true);
						});
					}
				} else if ($filter.hasClass('filter--sort')) {
					// If sort not in URL, check cookie
					const match = document.cookie.match(/(?:^| )w4d_sort=([^;]+)/);
					const value = match ? decodeURIComponent(match[1]) : 'default';
					$filter.find(`.filter__option[data-value="${value}"]`).addClass('is-selected').attr('aria-selected', 'true');
				}

				// Update UI for all filters
				this.updateResetButtonVisibility($panel);
				this.updateBadge($filter);
				this.updateSearchVisibility($filter);
				this.updateVisibleBounds($filter.find('.filter__option'));
			});

			if (shouldFetch && isInitialLoad) {
				// Preserve the current page (from /page/n/ in the URL) on initial load.
				// Passing `true` (pageClick) keeps the page segment instead of resetting to page 1.
				if (document.body.classList.contains('page-template-template-my-products')) {
					W4D_Pagination.fetchMyProducts(true);
				} else {
					W4D_Pagination.fetchProducts(true);
				}
			}
		}

		bindEvents() {
			const handleBreakpoint = (e) => {
				// Cached: reading mqMobile.matches later (e.g. in the overflow check after a web font swap) forces a
				// synchronous style recalculation of the whole page.
				this.isMobile = e.matches;

				if (e.matches) {
					// Screen is 992px or less
					this.$filtersContainer.addClass('filters--mobile');
					this.$filtersContainer.removeClass('filters--collapsed');
				} else {
					// Screen is larger than 992px
					this.$filtersContainer.removeClass('filters--mobile');

					// Optional: Cleanup mobile-only states when going back to desktop
					if (this.$filtersContainer.hasClass('filters--open')) {
						this.$filtersContainer.removeClass('filters--open filters--closing');
					}
				}
			};

			// Set initial state
			handleBreakpoint(this.mqMobile);

			// Listen for changes
			this.mqMobile.addEventListener('change', (e) => {
				handleBreakpoint(e);
				this.handleResponsivePopovers();
			});

			window.addEventListener('popstate', () => {
				this.initializeFiltersFromURL(false);
				this.updateGlobalResetButtonVisibility();
			});

			// 1. Mobile Toggle Logic
			this.$filtersToggle.on('click', () => {
				const windowWidth = $(window).width();

				if (windowWidth <= 992) {
					this.$filtersContainer.addClass('filters--open');
				}
			});

			$('[data-js="collapse-filters"]').on('click', () => {
				const windowWidth = $(window).width();
				const isAside = $('.filters').hasClass('filters--aside');

				// Only collapse if we are above 992px AND it's an "aside" layout
				if (windowWidth > 992 && isAside) {
					$('.filters').addClass('filters--collapsed');
				}
			});

			$('.filters__toggle--aside').on('click', (e) => {
				e.stopPropagation();
				this.$filtersContainer.removeClass('filters--collapsed');
			});

			$(document).on('click', (e) => {
				const $target = $(e.target);

				// ONLY run this logic if the mobile overlay is actually open
				if (this.$filtersContainer.hasClass('filters--open')) {
					// If the click is NOT inside the filters and NOT on the toggle button
					if (!$target.closest('.filters').length && !$target.closest('.filters__toggle').length) {
						this.closeMobileFilters();
					}
				}
			});

			// 1. Explicit Close Button (The 'X' in the mobile overlay)
			this.$filtersClose.on('click', (e) => {
				e.preventDefault();
				// Only run if the mobile menu is actually open
				if (this.$filtersContainer.hasClass('filters--open')) {
					this.closeMobileFilters();
				}
			});

			// 2. Mobile Submit/Apply Button
			this.$filtersSubmit.on('click', (e) => {
				// Only auto-close on mobile. On desktop, we want the sidebar to stay visible.
				if (window.innerWidth <= 992) {
					this.closeMobileFilters();
				}
			});

			this.$filters.on('mousedown', '.filter__trigger', (e) => {
				const targetId = $(e.currentTarget).attr('popovertarget');
				if (targetId) {
					const $panel = $(`#${targetId}`);
					// Store the state right BEFORE the native light dismiss happens
					const isOpen = $panel.length && $panel[0].matches(':popover-open');
					$(e.currentTarget).data('was-open', isOpen);
				}
			});

			this.$filters.on('input', 'input[type="search"]', this.handleSearch.bind(this));
			this.$filters.on('click', '.filter__reset', this.handleReset.bind(this));
			this.$sortFilter.on('click', '.filter__option', this.handleSortSelection.bind(this));

			this.$filters.on('change', 'input[type="checkbox"]', (e) => {
				const $checkbox = $(e.currentTarget);
				const $filter = $checkbox.closest('.filter');

				if ($filter.hasClass('filter--discount')) {
					this.updateDiscountURL($filter, $checkbox.is(':checked'));
				} else {
					const $panel = $filter.find('.filter__panel');
					this.updateResetButtonVisibility($panel);
					this.updateBadge($filter);
					this.updateURLWithFilterParams($filter);
				}

				this.updateGlobalResetButtonVisibility();

				// Ensure the checkbox or label stays focused after the change to help w4d-pagination.js logic
				if (document.activeElement !== $checkbox[0]) {
					$checkbox.focus();
				}
			});

			this.$filters.on('click', '.filter__trigger', (e) => {
				const $details = $(e.currentTarget).closest('details');
				const isShopInner = $details.hasClass('filter--shop-inner');

				if (isShopInner) {
					const targetId = $(e.currentTarget).attr('popovertarget');
					if (targetId) {
						const $panel = $(`#${targetId}`);
						if ($panel.length && typeof $panel[0].showPopover === 'function') {
							// e.detail is 0 for keyboard events (Enter/Space), > 0 for mouse clicks.
							// Keyboard events don't trigger mousedown/light-dismiss, so we check current state.
							const isMouseClick = e.detail > 0;
							const wasOpen = isMouseClick ? $(e.currentTarget).data('was-open') : $panel[0].matches(':popover-open');

							if (!wasOpen) {
								// It was closed, so open it
								$panel[0].showPopover();
							} else if ($panel[0].matches(':popover-open')) {
								// It was open. If it's a keyboard event, manually hide it.
								// If it was a mouse click, light dismiss already closed it, so we do nothing.
								$panel[0].hidePopover();
							}

							// Re-check aria-expanded after toggle
							$(e.currentTarget).attr('aria-expanded', $panel[0].matches(':popover-open') ? 'true' : 'false');
						}
					}
				}
			});

			this.$filters.on('dblclick', (e) => {
				if ($(e.target).is('input[type="search"]')) return;
				e.preventDefault();
				e.stopPropagation();
			});

			this.$filters.on('mousedown', '.filter__option', (e) => {
				if (e.detail > 1) {
					e.preventDefault();
				}
			});

			// Listen for the popover or accordion closing
			/*this.$filters.each((i, filter) => {
                filter.addEventListener('toggle', (e) => {
                    const $target = $(e.target);
                    let $trigger, $panel, isOpen;

                    if ($target.hasClass('filter')) {
                        // Accordion toggle (details element)
                        $trigger = $target.find('.filter__trigger');
                        $panel = $target.find('.filter__panel');
                        isOpen = $target.prop('open');
                    } else if ($target.hasClass('filter__panel')) {
                        // Popover toggle
                        $panel = $target;
                        $trigger = $panel.siblings('.filter__trigger');
                        isOpen = e.newState !== 'closed';
                    } else {
                        return;
                    }

                    if (!isOpen) {
                        this.clearSearch($panel);
                        $trigger.attr('aria-expanded', 'false');
                    } else {
                        $trigger.attr('aria-expanded', 'true');
                    }
                }, true); // Use capture to catch events from children (popover)
            });*/

			this.$resetAll.on('click', this.handleResetAll.bind(this));
			this.$expandFiltersBtn.on('click', (e) => this.handleExpandFiltersBtnClick(e));

			if (this.mqMobile && this.mqMobile.addEventListener) {
				this.mqMobile.addEventListener('change', () => this.scheduleOverflowCheck());
			}
		}

		closeMobileFilters() {
			this.$filtersContainer.addClass('filters--closing').removeClass('filters--open');

			this.$filtersContainer.one('transitionend', (e) => {
				if (e.target === this.$filtersContainer[0] && e.originalEvent.propertyName === 'transform') {
					this.$filtersContainer.removeClass('filters--closing');
				}
			});

			// Fallback in case transitionend doesn't fire
			setTimeout(() => {
				if (this.$filtersContainer.hasClass('filters--closing')) {
					this.$filtersContainer.removeClass('filters--closing');
				}
			}, 600);
		}

		handleSearch(e) {
			const searchTerm = $(e.currentTarget).val().toLowerCase().trim();
			const $panel = $(e.currentTarget).closest('.filter__panel');
			const $options = $panel.find('.filter__option');
			const $noResults = $panel.find('.filter__no-results');

			let hasResults = false;

			$options.each(function () {
				const $li = $(this);
				const labelText = $li.find('.field__label-text').text().toLowerCase().trim();

				if (labelText.includes(searchTerm)) {
					// SHOWING
					hasResults = true;
					$li.removeClass('is-hidden-search');
					requestAnimationFrame(() => {
						$li.removeClass('is-hiding-search');
					});
				} else {
					// HIDING
					$li.addClass('is-hiding-search');
					$li.one('transitionend', function (e) {
						if (e.originalEvent.propertyName === 'grid-template-rows') {
							if ($li.hasClass('is-hiding-search')) {
								$li.addClass('is-hidden-search');
							}
						}
					});
				}
			});

			// Handle "No Results" visibility
			if (searchTerm !== '' && !hasResults) {
				$noResults.attr('aria-hidden', 'false');
			} else {
				$noResults.attr('aria-hidden', 'true');
			}

			this.updateVisibleBounds($options);
		}

		updateResetButtonVisibility($panel) {
			const $resetWrapper = $panel.find('.filter__reset-wrapper');
			if (!$resetWrapper.length) return;

			const hasSelection = this.hasSelectedOptions($panel);
			$resetWrapper.attr('aria-hidden', hasSelection ? 'false' : 'true');
		}

		updateBadge($filter) {
			if ($filter.data('taxonomy') === 'price') {
				if (window.W4D_RangeFilter && typeof window.W4D_RangeFilter.toggleSelectedClass === 'function') {
					const $inputMin = $filter.find('.range-filter__input-min');
					const $inputMax = $filter.find('.range-filter__input-max');
					const minPrice = parseInt($inputMin.attr('data-unformatted-value')) || 0;
					const maxPrice = parseInt($inputMax.attr('data-unformatted-value')) || 0;
					window.W4D_RangeFilter.toggleSelectedClass($filter, minPrice, maxPrice);
				}
				return;
			}
			const $badge = $filter.find('.filter__badge');
			if (!$badge.length) return;

			let count = 0;
			let newText = '';

			if ($filter.hasClass('filter--sort')) {
				const $selected = $filter.find('.filter__option.is-selected');
				const value = $selected.data('value');
				if (value && value !== 'default') {
					count = 1;
					newText = $selected.find('.field__label-text').text().trim();
				}
			} else {
				const $selected = $filter.find('input[type="checkbox"]:checked');
				count = $selected.length;
				if (count > 0) {
					if (count === 1) {
						newText = $selected.closest('.field').find('.field__label-text').text().trim();
					} else {
						newText = count;
					}
				}
			}

			const isCurrentlyHidden = $badge.attr('aria-hidden') === 'true';

			if (count === 0) {
				if (!isCurrentlyHidden) {
					// Start hiding transition
					// Set current width to pixels to ensure smooth shrink animation
					$badge.css('width', $badge.outerWidth() + 'px');
					$badge[0].offsetHeight; // force reflow

					$badge.attr('aria-hidden', 'true');
					$badge.css('width', ''); // Let CSS handle transition to 0

					$badge.off('transitionend.badgeHide').one('transitionend.badgeHide', (e) => {
						if (e.originalEvent.propertyName === 'width' && $badge.attr('aria-hidden') === 'true') {
							$badge.text('');
							$badge.css('width', '');
						}
					});
				}
			} else {
				$badge.off('transitionend.badgeHide'); // Cancel any pending hide cleanup

				if (isCurrentlyHidden) {
					$badge.text(newText);
				} else {
					if ($badge.text() !== String(newText)) {
						$badge.text(newText);
					}
				}
				$badge.attr('aria-hidden', 'false');
			}
		}

		updateSearchVisibility($filter) {
			const $search = $filter.find('.filter__search');
			if (!$search.length) return;

			const threshold = 8;
			const $visibleOptions = $filter.find('.filter__option').not('[data-qty="0"]');

			if ($visibleOptions.length >= threshold) {
				$search.css('display', 'block');
			} else {
				$search.css('display', 'none');
			}
		}

		handleSortSelection(e) {
			const $option = $(e.currentTarget);
			const $filter = $option.closest('.filter');
			const value = $option.data('value');

			// Update UI
			$filter.find('.filter__option').removeClass('is-selected').attr('aria-selected', 'false');
			$option.addClass('is-selected').attr('aria-selected', 'true');

			// Ensure the option stays focused after the change to help w4d-pagination.js logic
			if (document.activeElement !== $option[0]) {
				$option.focus();
			}

			// Set cookie
			if (typeof W4D_FrontendHelper !== 'undefined' && W4D_FrontendHelper.setCookie) {
				W4D_FrontendHelper.setCookie('w4d_sort', value, null);
			} else {
				document.cookie = `w4d_sort=${value}; path=/; SameSite=Lax`;
			}

			// Update Badge
			this.updateBadge($filter);

			if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
				window.location.reload();
				return;
			}

			// Fetch products without updating URL with sort
			if (document.body.classList.contains('page-template-template-my-products')) {
				if (typeof W4D_Pagination !== 'undefined') W4D_Pagination.fetchMyProducts();
			} else {
				if (typeof W4D_Pagination !== 'undefined') W4D_Pagination.fetchProducts();
			}
		}

		hasSelectedOptions($panel) {
			return $panel.find('input[type="checkbox"]:checked').length > 0;
		}

		updateVisibleBounds($options) {
			$options.removeClass('is-first-visible is-last-visible');

			const $visible = $options.not('.is-hiding, .is-hidden, .is-hiding-search, .is-hidden-search, [data-qty="0"]');

			if ($visible.length) {
				$visible.first().addClass('is-first-visible');
				$visible.last().addClass('is-last-visible');
			}
		}

		clearSearch($panel) {
			const $input = $panel.find('input[type="search"]');
			if ($input.val() === '') return;
			$input.val('');
			const $options = $panel.find('.filter__option');
			const $noResults = $panel.find('.filter__no-results');
			$options.removeClass('is-hiding-search is-hidden-search is-first-visible is-last-visible');
			$noResults.attr('aria-hidden', 'true');
			this.updateVisibleBounds($options);
		}

		handleReset(e) {
			const $button = $(e.currentTarget);
			const $panel = $button.closest('.filter__panel');
			const $filter = $panel.closest('.filter');
			const taxonomy = $filter.data('taxonomy');
			const $inputs = $panel.find('.field__input');
			const $searchInput = $panel.find('input[type="search"]');
			const $options = $panel.find('.filter__option');
			const $noResults = $panel.find('.filter__no-results');

			$panel.addClass('is-resetting');
			setTimeout(() => {
				$panel.removeClass('is-resetting');
			}, 300);

			$inputs.prop('checked', false);

			if (taxonomy) {
				const url = new URL(window.location.href);
				url.searchParams.delete(taxonomy);
				window.history.pushState({}, document.title, url.toString());
			}

			if (taxonomy === 'price' && window.W4D_RangeFilter && typeof window.W4D_RangeFilter.resetFilter === 'function') {
				window.W4D_RangeFilter.resetFilter();
			}

			if (document.body.classList.contains('page-template-template-my-products')) {
				W4D_Pagination.fetchMyProducts();
			} else {
				W4D_Pagination.fetchProducts();
			}

			$searchInput.val('');
			$options.removeClass('is-hiding-search is-hidden-search is-first-visible is-last-visible');
			$noResults.attr('aria-hidden', 'true');

			this.updateResetButtonVisibility($panel);
			this.updateBadge($panel.closest('.filter'));
			this.updateVisibleBounds($options, $noResults);
			this.updateGlobalResetButtonVisibility();
		}

		w4d_clear_url_params() {
			const currentUrl = window.location.href.split('?')[0];
			const newUrl = new URL(currentUrl);

			window.history.pushState({}, document.title, newUrl.toString());

			if (document.body.classList.contains('page-template-template-my-products')) {
				W4D_Pagination.fetchMyProducts();
			} else {
				W4D_Pagination.fetchProducts();
			}
		}

		handleResetAll() {
			this.$filters.not('.filter--sort').find('input[type="checkbox"]').prop('checked', false);

			if (window.W4D_RangeFilter && typeof window.W4D_RangeFilter.resetFilter === 'function') {
				window.W4D_RangeFilter.resetFilter();
			}

			this.$filters.not('.filter--sort').each((i, el) => {
				const $filter = $(el);
				const $panel = $filter.find('.filter__panel');
				this.updateResetButtonVisibility($panel);
				this.updateBadge($filter);
				this.clearSearch($panel);
			});

			this.updateGlobalResetButtonVisibility();
			this.w4d_clear_url_params();
		}

		updateGlobalResetButtonVisibility() {
			const hasAnySelection = this.$filters.not('.filter--sort').find('input[type="checkbox"]:checked').length > 0;
			const url = new URL(window.location.href);
			const hasPriceSelection =
				url.searchParams.has('min_price') || url.searchParams.has('max_price') || url.searchParams.has('price');
			const shouldShow = hasAnySelection || hasPriceSelection;

			const isAside = this.$filtersContainer.hasClass('filters--aside');
			const isMobile = this.isMobile;

			const $headerReset = this.$headerReset.length
				? this.$headerReset
				: this.$filtersContainer.find('.filters__header .filters__reset-all');
			const $footerReset = this.$footerReset.length
				? this.$footerReset
				: this.$filtersContainer.find('.filters__expand-and-clear .filters__reset-all');

			if (isAside) {
				// Aside desktop: header reset-all is hidden, footer (expand-and-clear) is the one to show
				$headerReset.attr('aria-hidden', 'true');
				$footerReset.attr('aria-hidden', shouldShow ? 'false' : 'true');
			} else if (isMobile) {
				// Shop-inner mobile: .filters__header is flex, .filters__expand-and-clear is display:none
				$headerReset.attr('aria-hidden', shouldShow ? 'false' : 'true');
				$footerReset.attr('aria-hidden', 'true');
			} else {
				// Shop-inner desktop: .filters__header is display:none, .filters__expand-and-clear is flex
				$headerReset.attr('aria-hidden', 'true');
				$footerReset.attr('aria-hidden', shouldShow ? 'false' : 'true');
			}

			this.scheduleOverflowCheck();
		}

		initObserver() {
			if (this.$filtersContainer.hasClass('filters--aside')) return;
			if (!this.$filtersWrapper.length || !this.$expandFiltersBtn.length) return;

			this.itemWidths = new Map();
			this.containerWidth = 0;
			this.expandBtnWidth = 0;
			this.resetBtnWidth = 0;
			this._overflowCheckPending = false;

			this.resizeObserver = new ResizeObserver((entries) => {
				let shouldSchedule = false;

				for (const entry of entries) {
					const target = entry.target;
					const width =
						entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].inlineSize : entry.contentRect.width;

					if (target === this.$filtersWrapper[0]) {
						if (this.containerWidth !== width) {
							this.containerWidth = width;
							shouldSchedule = true;
						}
					} else if (this.$expandFiltersBtn.length && target === this.$expandFiltersBtn[0]) {
						if (width > 0 && this.expandBtnWidth !== width) {
							this.expandBtnWidth = width;
							shouldSchedule = true;
						}
					} else if (this.$footerReset.length && target === this.$footerReset[0]) {
						if (width > 0 && this.resetBtnWidth !== width) {
							this.resetBtnWidth = width;
							shouldSchedule = true;
						}
					} else if (target.classList.contains('filter')) {
						if (width > 0) {
							if (this.itemWidths.get(target) !== width) {
								this.itemWidths.set(target, width);
								shouldSchedule = true;
							}
						} else {
							if (this.itemWidths.has(target)) {
								this.itemWidths.delete(target);
								shouldSchedule = true;
							}
						}
					}
				}

				if (shouldSchedule) {
					this.scheduleOverflowCheck();
				}
			});

			this.resizeObserver.observe(this.$filtersWrapper[0]);
			this.$filters.each((i, el) => {
				this.resizeObserver.observe(el);
			});

			if (this.$footerReset.length) {
				this.resizeObserver.observe(this.$footerReset[0]);
			}
			if (this.$expandFiltersBtn.length) {
				this.resizeObserver.observe(this.$expandFiltersBtn[0]);
			}

			// No document.fonts.ready hook: a web font swap that changes a filter's width is reported by the observer.
		}

		scheduleOverflowCheck() {
			if (this._overflowCheckPending) return;
			this._overflowCheckPending = true;
			requestAnimationFrame(() => {
				this._overflowCheckPending = false;
				this.updateOverflowState();
			});
		}

		updateOverflowState() {
			if (this.$filtersContainer.hasClass('filters--aside')) return;
			if (!this.$filtersWrapper.length || !this.$expandFiltersBtn.length) return;
			if (this.isMobile) return;

			const containerWidth = this.containerWidth;
			if (containerWidth <= 0) return;

			const gap = 10;

			const visibleFilters = this.$filtersWrapper.children('.filter').not('[aria-hidden="true"]').toArray();

			if (visibleFilters.length === 0) {
				this.setOverflowState(false);
				return;
			}

			let totalFiltersWidth = 0;
			let count = 0;

			for (const el of visibleFilters) {
				const w = this.itemWidths ? this.itemWidths.get(el) : null;
				if (w && w > 0) {
					totalFiltersWidth += w;
					count++;
				}
			}

			if (count === 0) {
				this.setOverflowState(false);
				return;
			}

			const totalGaps = (count - 1) * gap;
			const totalFiltersAndGaps = totalFiltersWidth + totalGaps;

			const isResetVisible = this.$footerReset.attr('aria-hidden') === 'false';
			const resetWidth = isResetVisible ? this.resetBtnWidth || 90 : 0;
			const resetSpace = isResetVisible ? resetWidth + gap : 0;

			const widthNeededNoExpand = totalFiltersAndGaps + resetSpace;
			const isOverflowing = widthNeededNoExpand > containerWidth;

			this.setOverflowState(isOverflowing);
		}

		setOverflowState(isOverflowing) {
			this.$expandFiltersBtn.css('display', isOverflowing ? 'flex' : 'none');

			if (!isOverflowing) {
				this.$filtersWrapperOuter.removeClass('filters__wrapper-outer--expanded');
				this.$filtersExpandAndClearContainer.addClass('filters__expand-and-clear--expanded');
			} else {
				this.applyExpandedState();
			}
		}

		checkFiltersOverflow() {
			this.scheduleOverflowCheck();
		}

		handleExpandFiltersBtnClick() {
			if (!this.$filtersWrapperOuter.length) return;

			this.isExpanded = !this.isExpanded;
			this.applyExpandedState();
		}

		applyExpandedState() {
			this.$filtersWrapperOuter.toggleClass('filters__wrapper-outer--expanded', this.isExpanded);
			this.$filtersExpandAndClearContainer.toggleClass('filters__expand-and-clear--expanded', this.isExpanded);

			const isExpanded = this.$filtersExpandAndClearContainer.hasClass('filters__expand-and-clear--expanded');
			this.$expandFiltersBtn.find('span').html(isExpanded ? 'Manje filtera' : 'Više filtera');
		}

		prepareFlip() {
			this.firstPositions = {};
			const $children = this.$filtersWrapper.children('.filter, .filters__expand-and-clear');
			$children.each((i, el) => {
				const $el = $(el);
				const key = $el.hasClass('filters__expand-and-clear') ? 'expand-clear' : $el.data('taxonomy') || i;
				this.firstPositions[key] = el.getBoundingClientRect();
			});
		}

		applyFlip() {
			const $container = this.$filtersWrapper;
			if (!$container.length) return;

			const isAside = this.$filtersContainer.hasClass('filters--aside');
			const $filters = $container.children('.filter');
			const $expandAndClear = $container.children('.filters__expand-and-clear');

			// Sort filters.
			// Only attribute filters (data-taxonomy starting with "pa_") may flip
			// between each other based on selection. Everything else (price, stock,
			// product_cat, discounts, etc.) keeps its initial position.
			const tax = (el) => $(el).data('taxonomy');
			const initIdx = (el) => (this.initialOrder ? this.initialOrder.indexOf(tax(el)) : -1);
			const isPa = (el) => typeof tax(el) === 'string' && tax(el).indexOf('pa_') === 0;
			const isActive = (el) => $(el).find('.filter__badge').attr('aria-hidden') === 'false';

			// Start from the initial order to maintain slots for non-pa_ filters.
			const sortedFilters = $filters.toArray().sort((a, b) => {
				const idxA = initIdx(a);
				const idxB = initIdx(b);
				if (idxA !== -1 && idxB !== -1) return idxA - idxB;
				if (idxA !== -1) return -1;
				if (idxB !== -1) return 1;
				return 0;
			});

			// Reorder only pa_ filters within their own relative slots.
			const paSlots = [];
			sortedFilters.forEach((el, i) => {
				if (isPa(el)) paSlots.push(i);
			});

			if (paSlots.length > 0) {
				const paFilters = paSlots.map((i) => sortedFilters[i]);
				paFilters.sort((a, b) => {
					const activeA = isActive(a);
					const activeB = isActive(b);
					if (activeA && !activeB) return -1;
					if (!activeA && activeB) return 1;
					return initIdx(a) - initIdx(b);
				});
				paSlots.forEach((slot, k) => {
					sortedFilters[slot] = paFilters[k];
				});
			}

			// Reorder in DOM
			$container.append(sortedFilters);
			if ($expandAndClear.length) {
				$container.append($expandAndClear);
			}

			if (isAside) {
				// "Zasebna logika" za sidebar layout:
				// Samo preslagivanje bez FLIP animacije (ili jednostavnija logika)
				// jer u sidebaru animacija preslagivanja može biti zbunjujuća.
				return;
			}

			// FLIP animation
			const $toAnimate = $filters.add($expandAndClear);

			requestAnimationFrame(() => {
				$toAnimate.each((i, el) => {
					const $el = $(el);
					const key = $el.hasClass('filters__expand-and-clear') ? 'expand-clear' : $el.data('taxonomy') || i;
					const firstPos = this.firstPositions[key];
					if (!firstPos) return;

					const lastPos = el.getBoundingClientRect();
					const deltaX = firstPos.left - lastPos.left;
					const deltaY = firstPos.top - lastPos.top;

					if (deltaX === 0 && deltaY === 0) return;

					// Invert
					el.style.transition = 'none';
					el.style.transform = `translate(${deltaX}px, ${deltaY}px)`;

					// Play
					requestAnimationFrame(() => {
						el.style.transition = 'transform 300ms cubic-bezier(0.2, 0, 0.2, 1)';
						el.style.transform = '';

						// Clean-up
						$(el).one('transitionend', (e) => {
							if (e.originalEvent.propertyName === 'transform') {
								el.style.transition = '';
								el.style.transform = '';
							}
						});
					});
				});
			});

			this.scheduleOverflowCheck();
		}

		handleResponsivePopovers() {
			const $shopInnerFilters = $('.filters__wrapper .filter--shop-inner').not('.filter--sort');
			if (!$shopInnerFilters.length) return;

			const isMobile = window.innerWidth < 992;

			$shopInnerFilters.each((i, el) => {
				const $filter = $(el);
				const $trigger = $filter.find('.filter__trigger');
				const $panel = $filter.find('.filter__panel');

				if (isMobile) {
					// Remove attributes and store them if not already stored
					if ($trigger.attr('popovertarget')) {
						$trigger.data('popovertarget', $trigger.attr('popovertarget'));
						$trigger.removeAttr('popovertarget');
					}
					if ($panel.attr('popover')) {
						$panel.data('popover', $panel.attr('popover'));
						$panel.removeAttr('popover');
					}
				} else {
					// Restore attributes from data if they exist
					const storedTarget = $trigger.data('popovertarget');
					const storedPopover = $panel.data('popover');

					if (storedTarget) {
						$trigger.attr('popovertarget', storedTarget);
					}
					if (storedPopover) {
						$panel.attr('popover', storedPopover);
					}
				}
			});
		}

		updateDiscountURL($filter, isChecked) {
			const taxonomy = $filter.data('taxonomy'); // 'discounts'
			const url = new URL(window.location.href);

			if (isChecked) {
				url.searchParams.set(taxonomy, '1');
			} else {
				url.searchParams.delete(taxonomy);
			}

			window.history.pushState({}, '', url.toString());
			if (typeof W4D_Pagination !== 'undefined') W4D_Pagination.fetchProducts();
		}

		updateURLWithFilterParams($filter) {
			const taxonomy = $filter.data('taxonomy');
			if (!taxonomy) return;

			const selectedValues = [];
			$filter.find('input[type="checkbox"]:checked').each(function () {
				const $option = $(this).closest('.filter__option');
				if ($option.length) {
					selectedValues.push($option.data('value'));
				}
			});

			const url = new URL(window.location.href);
			if (selectedValues.length === 0) {
				url.searchParams.delete(taxonomy);
			} else {
				url.searchParams.set(taxonomy, selectedValues.join(','));
			}
			window.history.pushState({}, '', url.toString());

			if (document.body.classList.contains('page-template-template-my-products')) {
				W4D_Pagination.fetchMyProducts();
			} else {
				W4D_Pagination.fetchProducts();
			}
		}
	}

	$(document).ready(function () {
		window.W4D_Filters = new W4D_Filters();
	});
})(jQuery);
